var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('follow-btn-pack',{attrs:{"dataValues":_vm.objForFollowProp,"userDetails":_vm.designer,"buttonStyle":_vm.btnStyle,"depressed":true,"isAuthenticated":_vm.userIsAuthenticated,"allowAction":_vm.allowAction},on:{"click":function($event){return _vm.followUser(_vm.designer)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }